/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE. 
*/

"use client";

import {
	ArticleComponentsSection,
	CosmosComponentContextProps,
	getHero,
	getSections,
	SectionTypename,
} from "@cosmos/components";
import { PageBlogDetailFragment } from "@cosmos/hygraph-schema";
import { useAuth } from "@cosmos/next-hooks";

import { css } from "@panda/css";

import { TemplateProviders } from "../templates/TemplateProviders";

interface CosmosPageProps {
	pageData?: PageBlogDetailFragment;
	componentContext: CosmosComponentContextProps;
}

const sectionExtraProps = (__typename: SectionTypename): any => {
	return __typename === "CosmosSectionContentLargeImage" ? { enableAnimate: false } : {};
};

export const CosmosPageBlogDetail = ({ pageData, componentContext }: CosmosPageProps): React.JSX.Element => {
	useAuth(!componentContext.enableAuth);

	return (
		<TemplateProviders componentContext={componentContext}>
			{getHero(pageData?.hero, pageData?.blogConfig)}
			<div className={css({ paddingBlockStart: "eds.dimension.32", paddingBlockEnd: "eds.dimension.64" })}>
				<ArticleComponentsSection articleComponents={pageData?.articleComponents} nAnimatedAsset={2} />
				{pageData?.articleComponents.length && pageData?.refSections?.length ? (
					<div className={css({ paddingBlock: "eds.dimension.32" })} />
				) : (
					""
				)}
				{getSections(pageData?.refSections, sectionExtraProps)}
			</div>
		</TemplateProviders>
	);
};
